var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#0057FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79274 25.0158L26.3002 25.0158L21.3503 29.975C21.3073 30.0176 21.2732 30.0683 21.25 30.1241C21.2267 30.18 21.2147 30.2399 21.2147 30.3004C21.2147 30.3609 21.2267 30.4208 21.25 30.4767C21.2732 30.5325 21.3073 30.5832 21.3503 30.6258L23.5869 32.8717C23.6774 32.9537 23.7949 32.9994 23.9169 33C24.0365 33.0007 24.1516 32.9547 24.2377 32.8717L34.3211 22.7883C34.4056 22.7011 34.4529 22.5844 34.4529 22.4629C34.4529 22.3414 34.4056 22.2247 34.3211 22.1375L24.2377 12.0542C24.1968 12.0101 24.1471 11.9751 24.0919 11.9515C24.0366 11.9278 23.977 11.9159 23.9169 11.9167C23.7931 11.917 23.6744 11.9664 23.5869 12.0542L21.3503 14.2908C21.3073 14.3334 21.2732 14.3841 21.25 14.44C21.2267 14.4958 21.2147 14.5557 21.2147 14.6162C21.2147 14.6767 21.2267 14.7367 21.25 14.7925C21.2732 14.8484 21.3073 14.8991 21.3503 14.9417L27.2444 20.845L7.79273 20.845C7.67118 20.845 7.55463 20.8933 7.46868 20.9792C7.38273 21.0652 7.3344 21.1818 7.3344 21.3033L7.3344 24.53C7.33065 24.5925 7.33974 24.655 7.36109 24.7139C7.38244 24.7727 7.41561 24.8265 7.45855 24.872C7.50149 24.9175 7.55331 24.9538 7.61079 24.9785C7.66827 25.0032 7.73016 25.0159 7.79274 25.0158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.3b72e8409b59e968a8f797af9c552c0a.svg";
export { ForwardRef as ReactComponent };